import type { TaskTypeResponse } from '@erp/rpc';
import { useTaskTypeOutcomeOptions } from 'src/api/rpc/hooks/tasks/useTaskTypes';
import type { SingleSelectOption } from 'src/components/common/SingleSelect';
import {
  buildOutcomeOptions,
  queueOutcomeVocabulary,
} from './taskQueueFilterOptions';

/** Outcome filter options, scoped to the selected type's outcome vocabulary. */
export function useQueueOutcomeOptions({
  taskTypes,
  selectedTypeId,
  outcome,
}: {
  taskTypes: TaskTypeResponse[] | undefined;
  selectedTypeId: string | undefined;
  outcome: string | undefined;
}): SingleSelectOption[] {
  // A pinned Task Page type id arrives before the task types list loads.
  const selectedType = taskTypes?.find((type) => type.id === selectedTypeId);
  const typeOutcomes = useTaskTypeOutcomeOptions(selectedType?.outcomeEnumId);
  return buildOutcomeOptions(
    outcome,
    queueOutcomeVocabulary(
      selectedTypeId ? { kind: 'type', type: selectedType } : { kind: 'none' },
      typeOutcomes.data,
    ),
  );
}
